import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/vip.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-19d59c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "myUserPage" }
const _hoisted_2 = { class: "myUserForm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px"}
}, null, -1))
const _hoisted_4 = { class: "myUserContent" }

import API from "@/api";
import { ref } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import CalenderChart from "@/components/checkIn/CalenderChart.vue";
import PostList from "@/views/user/PostList.vue";
import AppList from "@/views/user/AppList.vue";
import AnswerList from "@/views/user/AnswerList.vue";
import UserEditPage from "@/components/trigger/UserEditPage.vue";
import AppFavourList from "@/views/user/AppFavourList.vue";
import PostFavourList from "@/views/user/PostFavourList.vue";
//查询登录用户

export default /*#__PURE__*/_defineComponent({
  __name: 'MyUserPage',
  setup(__props) {

const loginUserStore = useLoginUserStore();
const loginUser = ref<API.UserVO>(loginUserStore.loginUser);

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_icon_bookmark = _resolveComponent("icon-bookmark")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_icon_apps = _resolveComponent("icon-apps")!
  const _component_icon_star = _resolveComponent("icon-star")!
  const _component_icon_clock_circle = _resolveComponent("icon-clock-circle")!
  const _component_icon_settings = _resolveComponent("icon-settings")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_space, { size: "large" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            style: {"width":"60px","height":"60px"},
            "image-url": loginUser.value.userAvatar
          }, null, 8, ["image-url"]),
          _createVNode(_component_a_space, {
            direction: "vertical",
            style: {"margin-top":"-20px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: "large" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_typography_title, { heading: 5 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(loginUser.value.userName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_typography_text, {
                style: {"margin-top":"-10px"},
                type: "secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(loginUser.value.userProfile ? loginUser.value.userProfile : "暂无简介"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_a_tabs, { "lazy-load": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, { key: "post" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_bookmark),
              _createTextVNode(" 帖子 ")
            ]),
            default: _withCtx(() => [
              _createVNode(PostList, {
                "user-id": loginUser.value.id
              }, null, 8, ["user-id"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, { key: "app" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_apps),
              _createTextVNode(" 应用 ")
            ]),
            default: _withCtx(() => [
              _createVNode(AppList, {
                "user-id": loginUser.value.id
              }, null, 8, ["user-id"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, { key: "postFavour" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_star),
              _createTextVNode(" 帖子收藏 ")
            ]),
            default: _withCtx(() => [
              _createVNode(PostFavourList)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, { key: "appFavour" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_star),
              _createTextVNode(" 应用收藏 ")
            ]),
            default: _withCtx(() => [
              _createVNode(AppFavourList)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, { key: "userAnswer" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_clock_circle),
              _createTextVNode(" 结果答案记录 ")
            ]),
            default: _withCtx(() => [
              _createVNode(AnswerList, {
                "user-id": loginUser.value.id
              }, null, 8, ["user-id"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, { key: "brushingRecords" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_clock_circle),
              _createTextVNode(" 刷题记录 ")
            ]),
            default: _withCtx(() => [
              _createVNode(CalenderChart)
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, { key: "setting" }, {
            title: _withCtx(() => [
              _createVNode(_component_icon_settings),
              _createTextVNode(" 设置 ")
            ]),
            default: _withCtx(() => [
              _createVNode(UserEditPage)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})